import React from 'react'
import AppDrawer from '@components/Sidebar/AppDrawer'
import Footer from '@components/organisms/Footer'
import Navigation from '@components/organisms/Navigation'
import { AllFirstDepthCategory } from '@containers/Catalogs/AllFirstDepthCategory'
import { initializeApollo } from '@graphql/apolloClient'
import {
  FirstDepthCatalogCategoriesFragment,
  GetFirstDepthCategoriesDocument,
} from '@services/cloud/client'

type Props = {
  firstDepthCategories: FirstDepthCatalogCategoriesFragment[]
}

export default function AllCategoryPage(props: Props) {
  return (
    <>
      <AppDrawer>
        <AllFirstDepthCategory {...props} />
        <Footer />
        <Navigation />
      </AppDrawer>
    </>
  )
}

export async function getStaticProps() {
  const apolloClient = initializeApollo()

  const { data } = await apolloClient.query({
    query: GetFirstDepthCategoriesDocument,
  })

  return {
    props: {
      initialApolloState: apolloClient.cache.extract(),
      firstDepthCategories: data.firstDepthCategories,
    },
    revalidate: 60,
  }
}
